import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPublicSettings } from "@/lib/api";

export function Logo({ className = "", height = 40, light = false, showText = true }) {
  const [src, setSrc] = useState("/logo-mark.png");
  useEffect(() => {
    getPublicSettings().then((d) => { if (d.logo_url) setSrc(d.logo_url); }).catch(() => {});
  }, []);
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img
        src={src}
        alt="Credit Kendra logo"
        style={{ height }}
        className="w-auto object-contain drop-shadow-sm"
        onError={(e) => { e.currentTarget.onerror = null; if (!e.currentTarget.src.endsWith("/logo-mark.png")) e.currentTarget.src = "/logo-mark.png"; }}
      />
      {showText && (
        <div className="leading-tight">
          <div className={`font-display font-extrabold text-base tracking-tight whitespace-nowrap ${light ? "text-white" : "brand-navy"}`}>
            Credit Kendra
          </div>
          <div className={`text-[10px] font-semibold tracking-wide ${light ? "text-white/70" : "text-emerald-brand"}`}>
            Your Partner for Digital Growth
          </div>
        </div>
      )}
    </Link>
  );
}
